import { call, takeLatest, put, } from 'redux-saga/effects';
import { createAccountServiceAPI, createAdminServiceAPI} from '../../api/merchantAPI';
import { createAccountOTTERIACMRequestFailure, createAccountOTTERIACMRequest, createAccountOTTERIACMRequestSuccess, createAdminRequest, createAdminRequestFailure, createAdminRequestSuccess } from '../actions/accountServiceAction';

export function* createAccountServiceCall(action) {
   try {
      const response = yield call(createAccountServiceAPI, action);
      if (response?.status === 200) {
         yield put(createAccountOTTERIACMRequestSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(createAccountOTTERIACMRequestFailure(response)) : yield put(createAccountOTTERIACMRequestFailure(response));
      }
   } catch (e) {
      yield put(createAccountOTTERIACMRequestFailure(e.message));
   }
}

export function* createAdminServiceCall(action) {
   try {
      const response = yield call(createAdminServiceAPI, action);
      if (response?.status === 200) {
         yield put(createAdminRequestSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(createAdminRequestFailure(response)) : yield put(createAdminRequestFailure(response));
      }
   } catch (e) {
      yield put(createAdminRequestFailure(e.message));
   }
}

function* accountServiceSaga() {
    yield takeLatest(createAccountOTTERIACMRequest, createAccountServiceCall);
    yield takeLatest(createAdminRequest, createAdminServiceCall)
}
 
 export default accountServiceSaga;
